module.exports = __webpack_public_path__ + "static/media/money-pounds-twenty.bcf18620.svg";